<script lang="ts" setup>
import Popper from 'vue3-popper';

export type PopperPlacement =
  | 'auto'
  | 'auto-start'
  | 'auto-end'
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'left'
  | 'left-start'
  | 'left-end';

const props = withDefaults(
  defineProps<{
    theme?: 'primary' | 'secondary' | 'white' | '';
    placement?: PopperPlacement;
    arrow?: boolean;
    hover?: boolean;
    offsetDistance?: string;
  }>(),
  {
    theme: '',
    placement: 'auto',
    arrow: true,
    hover: true,
    offsetDistance: '12',
  },
);
</script>

<template>
  <template v-if="$slots.content">
    <Popper
      v-bind="$attrs"
      :class="props.theme"
      class="popover"
      :arrow="arrow"
      :hover="hover"
      :open-delay="hover ? 200 : 50"
      close-delay="100"
      :placement="placement"
      :offset-distance="offsetDistance"
      z-index="3"
    >
      <slot>
        <UiIcon name="AlertOctagon" class="trigger-icon icon-size-s" />
      </slot>
      <template #content="contentProps">
        <slot name="content" v-bind="contentProps" />
      </template>
    </Popper>
  </template>
  <template v-else>
    <slot />
  </template>
</template>

<style lang="scss" scoped>
// vue3-popper's theme variables, on the popover itself (the popper renders
// inside it). The 5px radius is the tooltip's own, on no scale step.
.popover {
  --popper-theme-background-color: var(--color-gray-900);
  --popper-theme-background-color-hover: var(--color-gray-900);
  --popper-theme-text-color: var(--color-gray-0);
  --popper-theme-border-radius: 5px;
  --popper-theme-padding: var(--space-6);
  --popper-theme-box-shadow: var(--shadow-md);
  font-size: var(--font-size-13);
}
.primary {
  --popper-theme-background-color: var(--color-primary-600);
  --popper-theme-background-color-hover: var(--color-primary-600);
  .trigger-icon {
    stroke: var(--color-primary-600);
  }
}

.secondary {
  --popper-theme-background-color: var(--color-bluegray-400);
  --popper-theme-background-color-hover: var(--color-bluegray-400);
  .trigger-icon {
    stroke: var(--color-bluegray-400);
  }
}

.white {
  --popper-theme-background-color: var(--color-gray-0);
  --popper-theme-background-color-hover: var(--color-gray-0);
  --popper-theme-text-color: var(--color-gray-900);
  .trigger-icon {
    stroke: var(--color-gray-900);
  }
}
</style>
